import React, { Component } from "react";
import PropTypes from "prop-types";
import { OfficerService } from "@services";
import Utils from "@utils";
import { Modal, Loader } from "../../../../../components";

const initialState = {
	showModal: false,
	groups: [],
	settings: {},
	error: false,
	loading: false,
};

class OfficerGroupsModal extends Component {
	constructor(props) {
		super(props);
		this.state = initialState;
	}

	static getDerivedStateFromProps({ groups, loading }, lastState) {
		const newState = {};
		if (lastState.groups.length !== groups.length) {
			newState.groups = groups;
		}

		if (lastState.loading !== loading) {
			newState.loading = loading;
		}

		return Object.keys(newState).length === 0 ? null : newState;
	}

	openModal = (settings, showModal = true) => {
		const state = { ...this.state };

		if (settings) {
			const { groups } = this.props;
			state.settings = settings;
			state.groups =
				settings.officerGroups && settings.officerGroups.length
					? settings.officerGroups
					: groups;
		}
		state.showModal = showModal;

		this.setState(state);
	};

	handleOnCancel = () => {
		const { groups, settings } = this.state;

		this.setState(
			{
				...initialState,
				groups: groups.map(group => ({ ...group, IsSelected: false })),
			},
			() => {
				if (settings.onCancel) {
					settings.onCancel();
				}
			},
		);
	};

	handleOnSubmit = event => {
		event.preventDefault();

		if (!this.validateGroups()) return;

		const { groups } = this.state;
		const officerGroups = groups.filter(group => group.IsSelected).map(group => group.Id);

		this.setOfficerGroup(officerGroups);
	};

	/**
	 * Updates an officer group with the necessary changes
	 * @param {Object} data the officer group object containg all its relevant data
	 */
	setOfficerGroup = data => {
		const { lang } = global;
		const { settings } = this.state;

		this.setState({ loading: true });

		OfficerService.setOfficerGroup({
			id: settings.officerId,
			data,
		})
			.then(() => {
				if (settings.onSuccess) {
					settings.onSuccess();
				}

				Utils.notify({
					type: "success",
					message: lang.t("Groups updated sucessfully"),
					title: lang.t("Success"),
				});

				this.handleOnCancel();
			})
			.catch(() => {
				Utils.notify({
					type: "error",
					message: lang.t("Error updating groups"),
					title: "Error",
				});

				this.setState({ loading: false });
			});
	};

	validateGroups = () => {
		const { groups } = this.state;
		const valid = !!groups.filter(group => group.IsSelected).length;
		if (!valid) {
			this.setState({ error: true });
		}

		return valid;
	};

	handleOnChecked = groupId => event => {
		const { groups } = this.state;

		const newGroups = groups.map(group => {
			if (group.Id === groupId) {
				return { ...group, IsSelected: event.target.checked };
			}

			return group;
		});

		this.setState({
			groups: newGroups,
			error: false,
		});
	};

	handleCancelClick = () => {
		const { settings } = this.state;

		if (!settings.isEdit) {
			this.handleOnCancel();
		} else {
			this.setOfficerGroup([]);
		}
	};

	render() {
		const { lang } = global;
		const { settings, groups, showModal, loading, error } = this.state;

		return (
			<Modal
				show={showModal}
				onHide={this.handleOnCancel}
			>
				<Loader active={loading} />
				<Modal.Header closeButton>
					<Modal.Title>{lang.t("Select Groups")}</Modal.Title>
				</Modal.Header>
				<Modal.Body>
					<div className="row">
						<div className="col-md-12">
							<strong className={settings.officerName ? "" : "hidden"}>
								{settings.officerName || ""}
							</strong>
							<hr className={settings.officerName ? "" : "hidden"} />
							<div className={`col-sm-${!settings.isEdit ? "8" : "12"}`}>
								<For
									each="group"
									of={groups}
								>
									<div
										className="form-group"
										key={group.Id}
									>
										<div className="checkbox">
											<label htmlFor={`officer_group_${group.Id}`}>
												<input
													type="checkbox"
													name={`officer_group_${group.Id}`}
													checked={group.IsSelected}
													onChange={this.handleOnChecked(group.Id)}
												/>
												{group.Name}
											</label>
										</div>
									</div>
								</For>
							</div>
							<If condition={!settings.isEdit}>
								<div className="col-sm-4 text-right">
									<button
										type="button"
										className="btn btn-primary btn-medium"
										onClick={settings.addGroup}
									>
										{`+ ${lang.t("New Group")}`}
									</button>
								</div>
							</If>
							<If condition={error}>
								<span className="text-danger">
									{lang.t("Select at least one group")}
								</span>
							</If>
						</div>
					</div>
				</Modal.Body>
				<Modal.Footer>
					<button
						type="button"
						className="btn btn-link"
						id="cancel-or-remove-officer"
						onClick={this.handleCancelClick}
					>
						{!settings.isEdit ? lang.t("Cancel") : lang.t("Remove Completely")}
					</button>
					<button
						type="button"
						id="add-or-update-officer-group"
						className="btn btn-primary btn-medium"
						onClick={this.handleOnSubmit}
					>
						{!settings.isEdit ? lang.t("Add Officer") : lang.t("Update Groups")}
					</button>
				</Modal.Footer>
			</Modal>
		);
	}
}

OfficerGroupsModal.propTypes = {
	groups: PropTypes.array,
	loading: PropTypes.bool,
};

OfficerGroupsModal.defaultProps = {
	groups: [],
	loading: false,
};

export default OfficerGroupsModal;
